import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@occc-app/design-system';
import { CustomDataPropertyValue } from './custom-data-property-value.component';

type CustomDataTableProps = {
  items: { key: string; value: unknown }[];
};

export const CustomDataTable = ({ items }: CustomDataTableProps) => {
  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Setting</TableCell>
            <TableCell>Value</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {items.map(({ key, value }) => (
            <TableRow key={key}>
              <TableCell>{key}</TableCell>
              <TableCell>
                <CustomDataPropertyValue value={value} />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
